// extracted by mini-css-extract-plugin
export default {"provider":"styles_provider__-Owg1"};